import { checkoutMode, checkoutStatusNote, commerceProducts } from '../data/commerce';

const currency = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });

export function Storefront() {
  const buyable = checkoutMode === 'external_buy_urls';
  const shopifyLocked = checkoutMode === 'shopify_password_locked';

  return (
    <section className="storefront-section" id="buy">
      <div className="section-heading">
        <p className="eyebrow">Commerce holding area</p>
        <h2>{shopifyLocked ? 'Drop 1 is ready locally. Shopify is still locked.' : 'Storefront staged. Checkout URLs pending.'}</h2>
        <p>
          {shopifyLocked
            ? checkoutStatusNote
            : 'Product pricing and SKU data are ready. Drop 1 now leads with the question line; current oath products stay visible as already-built/Drop 2 evolution items until checkout is verified.'}
        </p>
        <p>
          Want the corrected product story? Open <a href="/first-gen.html">the first-gen Drop 1 line</a>, <a href="/drop-architecture.html">the drop architecture</a>, <a href="/shop.html">the current Shopify holding page</a>, <a href="/commerce-next-20.html">the commerce execution status</a>, or <a href="/website-next-20.html">the Website Next 20</a>.
        </p>
      </div>
      <div className="commerce-grid">
        {commerceProducts.map((product) => {
          const price = currency.format(Number(product.price));
          return (
            <article className="commerce-card" key={product.id}>
              <p className="signal-label">{product.type}</p>
              <h3>{product.name}</h3>
              <p>{product.description}</p>
              <div className="commerce-meta">
                <strong>{price}</strong>
                <span>{product.sku}</span>
              </div>
              {buyable && product.buyUrl ? (
                <a className="button button-primary" href={product.buyUrl}>Buy now</a>
              ) : shopifyLocked && product.buyUrl ? (
                <>
                  <a className="button button-secondary button-locked" href={product.buyUrl}>Shopify product link</a>
                  <p className="commerce-lock-note">Store password still blocks checkout.</p>
                </>
              ) : (
                <button className="button button-disabled" type="button" disabled>
                  Provider/login pending
                </button>
              )}
            </article>
          );
        })}
      </div>
    </section>
  );
}
